module.exports = __webpack_public_path__ + "img/outside_night.fb35703b.jpg";